/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import can from 'can';
import dtm from 'scripts/services/dtm';

export const Topic = BaseControl.extend({
    init: function() {
        this._super();
        this.findContentTopics();
    },
    findContentTopics: function() {
        let searchContent = () => {
            this.topics = this.$element.closest('.l-topic').find('.m-topic');
            if (this.topics && this.topics.length) {
                this.activeRoute();
            }
        };
        let searchInterval = setInterval(() => {
            if (!this.topics || !this.topics.length) {
                searchContent();
            } else {
                clearInterval(searchInterval);
            }
        }, 300);
        searchContent();
    },
    activeRoute: function() {
        can.route.bind('section', (ev, tabIndex) => {
            if (!tabIndex) {
                return;
            }

            let topicTarget = this.$element.find('.m-topic').eq(tabIndex);

            if (!topicTarget.hasClass('is-open')) {
                this.$element
                    .find('.m-topic__title')
                    .attr('aria-expanded', false);
                this.$element
                    .find('.m-topic')
                    .not(topicTarget)
                    .removeClass('is-open')
                    .find('.m-topic__content')
                    .slideUp(250);

                topicTarget.find('.m-topic__title').attr('aria-expanded', true);
                topicTarget
                    .addClass('is-open')
                    .find('.m-topic__content')
                    .slideDown(250);

                setTimeout(
                    function() {
                        let scrollPosition = topicTarget.position().top,
                            topStrip = can.$('.m-header .s-top-strip');

                        if (topStrip.is(':visible')) {
                            scrollPosition -= topStrip.outerHeight(true);
                        }

                        can.$('html,body').animate(
                            { scrollTop: scrollPosition },
                            '150',
                        );
                    }.bind(this),
                    250,
                );
            }
        });

        can.route(':section', { section: 0 });
        can.route.ready();
    },
    '.m-topic__title click': function(element) {
        let topic = $(element).closest('.m-topic');
        if (topic.hasClass('is-open')) {
            topic
                .removeClass('is-open')
                .find('.m-topic__content')
                .slideUp('250');
            topic.find('.m-topic__title').attr('aria-expanded', false);
            can.route.removeAttr('section');
        } else {
            let openedItemIndex = this.$element.find('.m-topic').index(topic);
            dtm.trackKbygOpen(topic.attr('data-title'));
            can.route.attr('section', openedItemIndex);
        }
    },
});
